module.exports = "/build/web/svg/shopping-cart.7b9dbea25e55417c9cf6baeed5b1306a.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/shopping-cart.svg
// module id = 181
// module chunks = 24